import { render, staticRenderFns } from "./MeetingControlsComponent.vue?vue&type=template&id=04957d20&"
import script from "./MeetingControlsComponent.vue?vue&type=script&lang=js&"
export * from "./MeetingControlsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports